import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class CustomFieldViewModel extends DrObject {

    static CUSTOM_FIELD_PREFIX = 'drcustom-';

    model: Partial<CustomField>;

    constructor(value?: Partial<CustomField>) {
        super(DrObjectType.CUSTOM_FIELD, SupportedRegExType.PATTERNS);
        this.maxNameLength = DrObject.DefaultMaximumNameCharacters - CustomFieldViewModel.CUSTOM_FIELD_PREFIX.length;

        if (value) {
            this.model = value;
        }
    }

    formatName(name: string): string {
        const trimmedName = DrObject.trim(name);
        const isEmpty = DrObject.isEmpty(trimmedName);
        let formattedName = null;
        if (isEmpty === false) {
            formattedName = CustomFieldViewModel.CUSTOM_FIELD_PREFIX + trimmedName;
        }
        return formattedName;
    }
}

export class CustomField {
    name: string;
    description: string;
    dbType: string;
    dbTypeLength: number;
    displayCategory: string;
    includeInXML: boolean;
    overriddenByEmbedded: boolean;
    section: string;
    storeInIndex: boolean;
    tokenType: string;
    tokenizationType: string;
    withPositions: boolean;

    constructor(value?: Partial<CustomField>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}


export class CustomFieldProfileViewModel extends DrObject {

    model: Partial<CustomFieldProfileViewModel>;

    constructor(value?: Partial<CustomFieldProfileViewModel>) {
        super(DrObjectType.TEMPLATE);
    }
}


export class CustomFieldProfile {
    name: string;
    description: string;
    id: string;
    containerId: string;
    version: number;
    customMetadataFields: Array<CustomField>;
    default: boolean;

    constructor(value?: Partial<CustomFieldProfile>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
